import React from 'react';
import {translate} from "react-i18next";
import EnhancedModal from "../enhanced-modal";
import {Button} from "antd";

const HtmlTemplateViewer = ({
                              t,
                              title,
                              htmlPageUrl,
                              onClose
                            }) => {

  return (
    <EnhancedModal
      fullscreen
      visible={htmlPageUrl !== null}
      title={title}
      maskClosable={false}
      onCancel={onClose}
      bodyStyle={{position: "relative", padding: 0}}
      footer={
        <Button onClick={onClose}>
          {t('commons.buttons.close.title')}
        </Button>
      }
    >
      {htmlPageUrl && (
        <iframe
          title={"title"}
          src={htmlPageUrl}
          style={{position: "absolute", border: 0, width: "100%", height: "100%"}}
        />
      )}
    </EnhancedModal>
  );
};

export default translate()(HtmlTemplateViewer);
